import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import UrlRewriteTableColumns from '../../molecules/table-column/url-rewrite-table-columns'

const propTypes = {
  data              : PropTypes.array,
  pagination        : PropTypes.object,
  onFetchData       : PropTypes.func,
  selectButtonProps : PropTypes.shape({
    buttonSelectText    : PropTypes.string,
    buttonSelectColour  : PropTypes.string,
    onButtonSelectClick : PropTypes.func
  }),
  hiddenColumns : PropTypes.arrayOf(PropTypes.string),
  isLoading     : PropTypes.bool
}

const defaultProps = {
  selectButtonProps: {
    buttonSelectText    : '',
    buttonSelectColour  : '',
    onButtonSelectClick : () => {}
  },
  isLoading: false
}

/**
 * Table to display List of CMS Blog Posts
 * @param {Array<Object>} data - array of blog_post objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {object} selectButtonProps - Button Props for selecting row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */

const UrlRewriteTable = ({
  data,
  pagination,
  onFetchData,
  selectButtonProps,
  hiddenColumns,
  isLoading
}) => {

  const { buttonSelectText, buttonSelectColour, onButtonSelectClick } = selectButtonProps

  const columns = useMemo(() => UrlRewriteTableColumns({
    buttonSelectText,
    buttonSelectColour,
    onButtonSelectClick
  }),
  [ buttonSelectText, buttonSelectColour, onButtonSelectClick ])


  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

UrlRewriteTable.propTypes    = propTypes
UrlRewriteTable.defaultProps = defaultProps

export default UrlRewriteTable
